import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { colorGray } from 'styles/layout/colors';
import PropTypes from 'prop-types';
const IconPlus = t0 => {
  const $ = _c(8);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      color: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const color = t1 === undefined ? colorGray : t1;
  let t2;
  if ($[3] !== color) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M3 13.25H21.385V11.75H3V13.25Z" fill={color} />;
    $[3] = color;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== props || $[6] !== t2) {
    t3 = <svg width="12" height="12" viewBox="0 0 24 24" fill="none" {...props}>{t2}</svg>;
    $[5] = props;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
IconPlus.propTypes = {
  color: PropTypes.string
};
export default IconPlus;